import React from 'react'

import AndroidHandler from 'utils/androidHandler'
import { SocialShareDrawer } from 'components/SocialShareDrawer'

const useShowSocialDrawer = (params: {
  shareText: string
  shareUrl?: string
  drawerTitle: string
}) => {
  const androidHandler = AndroidHandler()
  const [showShareDrawer, setShowShareDrawer] = React.useState(false)
  const toggleDrawer = () => setShowShareDrawer((show) => !show)

  const triggerShareDialog = () => {
    if (androidHandler.enabled) {
      androidHandler.shareToolkitUrl(params.shareText)
    } else {
      toggleDrawer()
    }
  }

  return {
    triggerShareDialog,
    Drawer: () => (
      <SocialShareDrawer
        title={params.drawerTitle}
        isOpen={showShareDrawer}
        onClose={toggleDrawer}
        shareUrl={params.shareUrl || window.location.href}
        shareText={params.shareText}
        linkOnlyOnCopy
      />
    ),
  }
}

export default useShowSocialDrawer
